import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

const BrandIndex = () => import("@/views/pages/brands/Index");

// Views
// const Welcome = () => import('@/views/pages/Welcome')
const ProductIndex = () => import("@/views/pages/product/Index");
const ProductDetails = () => import("@/views/pages/product/Details");
const ProductImport = () => import("@/views/pages/product/ImportData");
const QuestionIndex = () => import("@/views/pages/question/Index");
const QuestionDetails = () => import("@/views/pages/question/Details");
const ReviewIndex = () => import("@/views/pages/reviews/Index");
const ReviewDetails = () => import("@/views/pages/reviews/Details");
const OrderIndex = () => import("@/views/pages/order/Index");
const OrderDetails = () => import("@/views/pages/order/Details");
const FinanceIndex = () => import("@/views/pages/finance/Index");
const FinanceAccountStatement = () =>
  import("@/views/pages/finance/Details/AccountStatement");
const FinanceOrderOverview = () =>
  import("@/views/pages/finance/Details/OrderOverview");
const FinanceTransactionOverview = () =>
  import("@/views/pages/finance/Details/TransactionOverview");
const ProfileIndex = () => import("@/views/pages/profile/Index");

const ReturnIndex = () => import("@/views/pages/return/Index");
const ReturnDetails = () => import("@/views/pages/return/Details");
const ArticleIndex = () => import("@/views/pages/article/Index");
const ArticleDetails = () => import("@/views/pages/article/Details");

const CampaignIndex = () => import("@/views/pages/campaign/Index");
const CampaignInfo = () => import("@/views/pages/campaign/Info");
const CampaignProductList = () => import("@/views/pages/campaign/ProductList");
const CampaignDetails = () => import("@/views/pages/campaign/Details");
const Dashboard = () => import("@/views/pages/dashboard/Index");
const RevenueProduct = () => import("@/views/pages/dashboard/RevenueProduct");
const DashboardTable = () => import("@/views/pages/dashboard/TableList");
const FAQ = () => import("@/views/pages/faq/Index");
const BannerIndex = () => import("@/views/pages/settings/Index");
const BannerDetails = () => import("@/views/pages/settings/Details");
const BannerWyswygi = () => import("@/views/pages/settings/Wyswygi");
const ResendOrderIndex = () => import("@/views/pages/resendorder/Index");
const ResendOrderDetails = () => import("@/views/pages/resendorder/Details");

const ChatIndex = () => import("@/views/pages/chat/Index");
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");
const ForgetPassword = () => import("@/views/pages/ForgetPassword");
const ResetPassword = () => import("@/views/pages/ResetPassword");
const TermAndCon = () => import("@/views/pages/TermAndCon");
const Privacy = () => import("@/views/pages/Privacy");

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { requiresIsLogin: true },
    },
    {
      path: "/register",
      name: "register",
      component: Register,
    },
    {
      path: "/forgetpassword",
      name: "forgetPass",
      component: ForgetPassword,
    },
    {
      path: "/resetpassword/:token",
      name: "resetPass",
      component: ResetPassword,
    },
    {
      path: "/termandcondition",
      name: "termandcon",
      component: TermAndCon,
    },
    {
      path: "/privacypolicy",
      name: "privacy",
      component: Privacy,
    },
    {
      path: '/brands',
      name: 'brands',
      component: BrandIndex,
    },
    {
      path: "/",
      redirect: "/dashboard/productoverview",
      name: "homePage",
      component: TheContainer,
      meta: { 
        requiresAuth: true
      },
      children: [
        // {
        //   path: '/',
        //   name: 'Welcome',
        //   component: Welcome,
        //   meta: { 
          // requiresAuth: true
        // },
        // },
        {
          path: "/dashboard/productoverview",
          name: "dashboard",
          component: Dashboard,
          meta: { 
            requiresAuth: true,
            lv: 2, 
            activeUrl: "/dashboard/productoverview"
          },
        },
        {
          path: "/dashboard/revenueproduct",
          name: "dbRevenueProduct",
          component: RevenueProduct,
          meta: { 
            requiresAuth: true,
            lv: 2, 
            activeUrl: "/dashboard/revenueproduct"
          },
        },
        {
          path: "/dashboard/performance",
          name: "dbPerformance",
          component: DashboardTable,
          meta: { 
            requiresAuth: true,
            lv: 2, 
            activeUrl: "/dashboard/performance"
          },
        },
        {
          path: "/dashboard/campaign",
          name: "dbCampaign",
          component: DashboardTable,
          meta: { 
            requiresAuth: true,
            lv: 2, 
            activeUrl: "/dashboard/campaign"
          },
        },
        {
          path: "/dashboard/productperformance",
          name: "dbProductPerformance",
          component: DashboardTable,
          meta: { 
            requiresAuth: true,
            lv: 2, 
            activeUrl: "/dashboard/productperformance"
          },
        },
        {
          path: 'product',
          redirect: '/product',
          name: 'productList',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: '',
              component: ProductIndex,
              meta: { 
                requiresAuth: true,
                activeUrl: "/product",
                lv: 1
              }
            },
            {
              path: 'details/:id',
              name: 'productDetails',
              component: ProductDetails,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/product",
                lv: 1 
              },
            },
            {
              path: 'importdata',
              name: 'importprodata',
              component: ProductImport,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/product",
                lv: 1 
              },
            },
          ]
        },
        {
          path: 'question',
          redirect: '/question',
          name: 'questionList',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: '',
              component: QuestionIndex,
              meta: { 
                requiresAuth: true,
                activeUrl: "/question",
                lv: 1
              }
            },
            {
              path: 'details/:id',
              name: 'questionDetails',
              component: QuestionDetails,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/question",
                lv: 1 
              },
            },
          ]
        },
        {
          path: 'review',
          redirect: '/review',
          name: 'reviewList',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: '',
              component: ReviewIndex,
              meta: { 
                requiresAuth: true,
                activeUrl: "/review",
                lv: 1
              }
            },
            {
              path: 'details/:id',
              name: 'reviewDetails',
              component: ReviewDetails,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/review",
                lv: 1 
              },
            },
          ]
        },
        {
          path: "/finance",
          redirect: "/finance/account-statement",
          name: "finance",
          component: FinanceIndex,
          meta: { 
            requiresAuth: true
          },
          children: [
            {
              path: "/finance/account-statement",
              name: "accountStatement",
              component: FinanceAccountStatement,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/finance/account-statement",
                lv: 1
              },
            },
            {
              path: "/finance/order/:id/:tab/:formStatus?",
              name: "orderOverview",
              // namePath: "finance-order-params",
              component: FinanceOrderOverview,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/finance/account-statement",
                lv: 1
              },
            },
            {
              path: "/finance/order",
              name: "orderOverview",
              component: FinanceOrderOverview,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/finance/account-statement",
                lv: 1
              },
            },
            {
              path: "/finance/transaction",
              name: "transactionOverview",
              component: FinanceTransactionOverview,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/finance/account-statement",
                lv: 1
              },
            },
          ],
        },
        {
          path: 'campaign',
          redirect: '/campaign',
          name: 'campaignListDb',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: '',
              component: CampaignIndex,
              meta: { 
                requiresAuth: true,
                activeUrl: "/campaign",
                lv: 1
              }
            },
            {
              path: 'info/:id',
              name: 'campaignInfo',
              component: CampaignInfo,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/campaign",
                lv: 1 
              },
            },
            {
              path: 'details/:id',
              name: 'campaignDetails',
              component: CampaignDetails,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/campaign",
                lv: 1 
              },
            },
            {
              path: 'details/productlist/:id',
              name: 'campaignProductList',
              component: CampaignProductList,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/campaign",
                lv: 1 
              },
            },
          ]
        },
        {
          path: "/profile/:menu",
          name: "profile",
          component: ProfileIndex,
          meta: { 
            requiresAuth: true,
            isChildren: true, 
            activeUrl: "/profile/general",
            lv: 1 
          },
        },
        {
          path: 'order',
          redirect: '/order',
          name: 'orderOverview',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: '',
              component: OrderIndex,
              meta: { 
                requiresAuth: true,
                activeUrl: "/order",
                lv: 1
              }
            },
            {
              path: 'details/:id',
              name: 'orderDetails',
              component: OrderDetails,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/order",
                lv: 1 
              },
            },
          ]
        },
        {
          path: 'resendorder',
          redirect: '/resendorder',
          name: 'resendOrder',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: '',
              component: ResendOrderIndex,
              meta: { 
                requiresAuth: true,
                activeUrl: "/resendorder",
                lv: 1
              }
            },
            {
              path: 'details/:id',
              name: 'resendOrderDetails',
              component: ResendOrderDetails,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/resendorder",
                lv: 1 
              },
            },
          ]
        },
        {
          path: 'return',
          redirect: '/return',
          name: 'returnOverview',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: '',
              component: ReturnIndex,
              meta: { 
                requiresAuth: true,
                activeUrl: "/return",
                lv: 1
              }
            },
            {
              path: 'details/:id',
              name: 'returnDetails',
              component: ReturnDetails,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/return",
                lv: 1 
              },
            },
          ]
        },
        {
          path: 'article',
          redirect: '/article',
          name: 'articleList',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: '',
              component: ArticleIndex,
              meta: { 
                requiresAuth: true,
                activeUrl: "/article",
                lv: 1
              }
            },
            {
              path: 'details/:id',
              name: 'articleDetails',
              component: ArticleDetails,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/article",
                lv: 1 
              },
            },
          ]
        },
        {
          path: "/chat",
          name: "chat",
          component: ChatIndex,
          meta: { 
            requiresAuth: true,
            activeUrl: "/chat",
            lv: 1
          },
        },
        {
          path: "/faq",
          name: "FAQList",
          component: FAQ,
          meta: { 
            requiresAuth: true,
            activeUrl: "/faq",
            lv: 1
          },
        },
        {
          path: 'banner',
          redirect: '/banner',
          name: 'bannerList',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: '',
              component: BannerIndex,
              meta: { 
                requiresAuth: true,
                activeUrl: "/banner",
                lv: 2
              }
            },
            {
              path: 'details/:id',
              name: 'bannerDetails',
              component: BannerDetails,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/banner",
                lv: 2 
              },
            },
          ]
        },
        {
          path: 'bannerpromotion',
          redirect: '/bannerpromotion',
          name: 'bannerPromotionList',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: '',
              component: BannerIndex,
              meta: { 
                requiresAuth: true,
                activeUrl: "/bannerpromotion",
                lv: 2
              }
            },
            {
              path: 'details/:id',
              name: 'bannerPromotionDetails',
              component: BannerDetails,
              meta: { 
                requiresAuth: true,
                isChildren: true, 
                activeUrl: "/bannerpromotion",
                lv: 2 
              },
            },
          ]
        },
        {
          path: "/about-store",
          name: "aboutStore",
          component: BannerWyswygi,
          meta: { 
            requiresAuth: true,
            isChildren: true, 
            activeUrl: "/about-store",
            lv: 2 
          },
        },
        // {
        //   path: '/',
        //   redirect: '/',
        //   name: 'Theme',
        //   component: {
        //     render(c) { return c('router-view') }
        //   },
        //   children: [
        //     {
        //       path: '/',
        //       name: 'Home',
        //       component: Home
        //     },
        //   ]
        // },
        {
          path: "404",
          name: "page404",
          component: Page404,
        },
        {
          path: "500",
          name: "page500",
          component: Page500,
        },
        // {
        //   path: "*",
        //   name: "Page404",
        //   component: Page404,
        // },
      ],
    },
    {
      path: "*",
      name: "page404",
      component: Page404,
    },
  ],
});

// function configRoutes() {} 
